var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config.data)?_c('dv-active-ring-chart',{staticStyle:{"width":"100%","height":"100%"},attrs:{"config":_vm.config}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }